import { IEvent } from "modules/event/types";
import {
  sendDeleteRequest,
  sendGetRequest,
  sendPostRequest,
  sendPutRequest,
} from "services/apiService";
import { IMember } from "./ManagersList";

export const getAllActiveEvents = (companyId: string) =>
  sendGetRequest<APIResponse<{ events: IEvent[] }>>(
    `/company-event/${companyId}/all-events`,
  );

export const getMembersReq = (companyId: string) =>
  sendGetRequest<APIResponse<{ members: IMember[] }>>(
    `/company/${companyId}/members`,
  );

interface IAddMemberReq {
  email: string;
  events: string[];
  role: string;
}

export const addMemberReq = (companyId: string, data: IAddMemberReq) =>
  sendPostRequest<typeof data, APIResponse<{ members: IMember[] }>>(
    `/company/${companyId}/member`,
    data,
  );

interface IUpdateMemberReq {
  role: string | undefined;
  pending: boolean;
}

export const updateMemberReq = (
  companyId: string,
  memberId: string,
  data: IUpdateMemberReq,
) =>
  sendPutRequest<typeof data, APIResponse<{ members: IMember[] }>>(
    `/company/${companyId}/member/${memberId}`,
    data,
  );

interface IUpdateAssistantReq {
  events: string[] | undefined;
  pending: boolean;
}

export const updateAssistantReq = (
  companyId: string,
  memberId: string,
  data: IUpdateAssistantReq,
) =>
  sendPutRequest<typeof data, APIResponse<{ members: IMember[] }>>(
    `/company/${companyId}/assistant/${memberId}`,
    data,
  );

interface IDeleteMemberReq {
  pending: boolean;
}

export const deleteMemberReq = (
  companyId: string,
  memberId: string,
  data: IDeleteMemberReq,
) =>
  sendDeleteRequest<typeof data, APIResponse<{ members: IMember[] }>>(
    `/company/${companyId}/member/${memberId}`,
    data,
  );
